import React from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
// core components
import GridItem from 'components/Grid/GridItem.jsx'
import Button from 'components/CustomButtons/Button.jsx'
import Card from 'components/Card/Card.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardBody from 'components/Card/CardBody.jsx'

const styles = {
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: '400',
      lineHeight: '1'
    }
  }
}

function TableList(props) {
  const { classes } = props
  return (
    <Grid container>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardBody>
            <p>
              <a href="#ja">日本語</a> / <a href="#en">English</a>
            </p>
          </CardBody>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 id="ja" className={classes.cardTitleWhite}>
              個人情報の取り扱いについて
            </h4>
          </CardHeader>
          <CardBody>
            <p>
              当アプリケーションでは、広告表示、オンラインランキング、プレイ状況管理のため、お客様の個人情報を収集させていただくことがございます。
            </p>
            <p>
              お客様からご提供いただく個人情報を、適切に保護することが重要であると認識し、以下のように個人情報保護方針を定めます。
            </p>
          </CardBody>
        </Card>

        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>個人情報保護方針</h4>
          </CardHeader>
          <CardBody>
            <h5>１．個人情報は適切に利用します</h5>
            <p>
              個人情報を本人の意思に反して収集、利用することは、権利の侵害になると共に、事業者としての信頼を失うことになります。そのため、個人情報の収集、利用等のルールを明文化し、適切な取扱いを行います。また、法的な要請を除き、本人の許可なく第三者に情報を開示・提供することはありません。
            </p>
            <h5>２．個人情報の厳正な管理を行います</h5>
            <p>
              個人情報の紛失、破壊、改ざん、および漏えい等を防止するため、不正アクセス対策、ウイルス対策等の情報セキュリティ対策を行い、適切に管理いたします。また、不要になった個人情報はすみやかに廃棄いたします。
            </p>
            <h5>３．法令およびその他の規範を遵守します</h5>
            <p>
              個人情報の取り扱いに関して、個人情報保護法をはじめとする個人情報に関する法令およびその他の規範を遵守します。
            </p>
            <h5>４．個人情報保護方針の継続的改善を行います</h5>
            <p>
              ここで定めた個人情報保護方針は、定期的に見直しを行い、継続的な改善を行います。また、個人情報保護方針とその運営に関して、疑問に思われる点や不都合な点等がありましたら、下記の問合わせ窓口までご連絡ください。検討を行い、適切に改善を行います。
            </p>
          </CardBody>
        </Card>

        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>
              本方針および個人情報の取り扱いに関するお問合せ窓口
            </h4>
          </CardHeader>
          <CardBody>
            <Button
              onClick={() =>
                (window.location =
                  'https://docs.google.com/forms/d/e/1FAIpQLSfii1neaSmcxGnrQk3ZqXC4R9YY8HFS-wMH5sK3bpg2GFm_SA/viewform')
              }
            >
              お問合せフォーム
            </Button>
          </CardBody>
        </Card>
      </GridItem>

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <h4 id="en" className={classes.cardTitleWhite}>
              About the handling of personal information
            </h4>
          </CardHeader>
          <CardBody>
            <p>
              In this application, we may collect your personal information for
              online ranking, advertisement display, play status management.
            </p>
            <p>
              We recognize that it is important to properly protect the personal
              information you provide from us, and we will establish the
              personal information protection policy as follows.
            </p>
          </CardBody>
        </Card>

        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>Privacy policy</h4>
          </CardHeader>
          <CardBody>
            <h5>1. We will use personal information appropriately</h5>
            <p>
              Collecting and using personal information contrary to the
              intention of the individual will infringe on the right and lose
              the trust as a business. For that reason, we will clarify the
              rules for collecting personal information, usage, etc. and
              handling it appropriately. Also, except for legal requests, we do
              not disclose / provide information to third parties without your
              consent.
            </p>
            <h5> 2. We will strictly manage personal information </h5>
            <p>
              <p>
                In order to prevent the loss, destruction, tampering, leakage,
                etc. of personal information, information security measures such
                as unauthorized access countermeasure, virus countermeasure etc
                are carried out and managed appropriately. Also, we will
                promptly discard unnecessary personal information.
              </p>
            </p>
            <h5> 3. We will comply with laws and other norms </h5>
            <p>
              Regarding the handling of personal information, we will comply
              with laws and other norms concerning personal information
              including the Personal Information Protection Law.
            </p>
            <h5>
              {' '}
              4. We will continuously improve our personal information
              protection policy{' '}
            </h5>
            <p>
              Regarding the personal information protection policy stipulated
              here, we regularly review it and make continuous improvements.
              Also, if you have any questions or disadvantages regarding the
              privacy policy and its management, please contact the following
              inquiries. We will review and make appropriate improvements.
            </p>
          </CardBody>
        </Card>

        <Card>
          <CardHeader color="primary">
            <h4 className={classes.cardTitleWhite}>
              Inquiries window on handling of this policy and personal
              information
            </h4>
          </CardHeader>
          <CardBody>
            <Button
              onClick={() =>
                (window.location =
                  'https://docs.google.com/forms/d/e/1FAIpQLSfii1neaSmcxGnrQk3ZqXC4R9YY8HFS-wMH5sK3bpg2GFm_SA/viewform')
              }
            >
              Contact form
            </Button>
          </CardBody>
        </Card>
      </GridItem>
    </Grid>
  )
}

export default withStyles(styles)(TableList)
